export default __webpack_public_path__ + "static/media/tutorial-step-2-sweepstakes.9365ec7b.png";